import React from 'react';
import { Button, Popup } from 'semantic-ui-react';

export type Props = {
  isFiltering?: boolean;
};

const FilterPopup: React.FC<Props> = ({ children, isFiltering }) => {
  return (
    <Popup
      hideOnScroll
      pinned
      position="bottom right"
      on="click"
      trigger={
        <Button
          basic={!isFiltering}
          primary={isFiltering}
          icon="filter"
          className="ml-24"
          color={isFiltering ? 'purple' : 'grey'}
        />
      }
    >
      {children}
    </Popup>
  );
};

export default FilterPopup;
